import React from "react";
import Phero from "../../components/phero";
import Head from "../../components/head";

const Post = () => {
  return (
    <>
      <Head
        title="OET Speaking Evaluation – Clinical Communication Skill Criteria"
        dis="New revised speaking evaluation criteria that came into effect from
            September 2018 include main features."
      />
      <div className="post">
        <Phero herotitle="OET Speaking Evaluation – Clinical Communication Skill Criteria" />
        <div className="post-content container">
          <p>
            New revised speaking evaluation criteria that came into effect from
            September 2018 include main features.
          </p>
          <p>
            <li>Linguistic features</li>
            <li>Clinical Communication skill features</li>
          </p>
          <p>
            Linguistic features are the same as other English exams such as
            IELTS/PTE. However, clinical communication skill criteria are for
            the first time introduced in any language test.
          </p>
          <p>
            This series of blogs attempt to explain what are these Clinical
            Communication Skill Criteria and what should a student do to score 2
            out of 3 on each criterion.
          </p>
          <p>
            The focus of this blog is on Relationship Building. Over the decade
            of experience in English teaching, I have been able to recognize the
            fact that in any of the international exams, the main difficulty a
            student focus is the difference in culture. For this reason, the
            students are unable to understand what gestures or language is
            acceptable by the people of other culture. For the very same reason,
            in spite of being proficient in English, most of the OET aspirants
            do not score well in Relationship Building Criteria.
          </p>
          <p>
            As with any other relationship, trust and acceptance are the
            foundation of your relationship with your patients. Relationship
            building means making the patient comfortable during the
            interaction. It starts with listening to the patient attentively by
            using phrases such
            <strong>
              ‘Hm’, ‘ok’, ‘oh I See’, ‘ I am sorry to hear that’
            </strong>{" "}
            and acknowledging their perspective. The patient is more likely to
            open up about their concerns if they feel accepted. Acceptance of
            their point of view helps the health professional to build trust.
            For Example, I have seen many students responding{" "}
            <strong>“It is a very bad habit”</strong> when the patient discloses
            about their smoking and drinking habit. This happens mainly due to
            the health professional’s cultural beliefs where certain habits are
            socially unacceptable. Although the student might be expressing his
            concern regarding the negative impacts of their habits on the
            patient’s health, using phrases such as ‘bad habit’ can switch the
            patient off.
          </p>
          <p>
            On the other hand, if health professionals can use the language of
            acceptance such as
            <strong>
              “I know where you come from “,” we often get into certain habits
              accidentally”
            </strong>
            , and then,
            <strong>
              “because of our increasing dependence on those things”
            </strong>
            . We tend to feel helpless about those habits. However, if you
            agree, I can discuss some very effective strategies which will help
            you to overcome your habits. Would you like to know more about? This
            positive outlook can help to persuade the patient for smoking
            cessation.
          </p>
          <p>
            In a nutshell, relationship building means recognising the fact that
            each patient may have their own set of beliefs based on the culture
            they were brought up in. Therefore, encouraging them to express a
            perspective on the matter being discussed will help you as an ‘OET
            candidate’ to know his perspective and build a greater sense of
            trust with them.
          </p>
        </div>
      </div>
    </>
  );
};

export default Post;
